import React from 'react';

import { CapaQuotationChatMessage } from '@generated/graphql';

import { colorSet } from '@components/Provider';
import { CustomizedTypography } from '@components/Customized';

import { Grid, Divider } from '@material-ui/core';
import { ErrorOutlined } from '@material-ui/icons';

interface Props {
  data?: CapaQuotationChatMessage;
}

const TerminationBubble: React.FC<Props> = ({ data }) => {
  const organizationName = data?.organizationName ?? '';
  const managerName = data?.managerName ?? '';

  return (
    <div className="message-container">
      <Divider className="message-divider" />
      <Grid
        container
        alignItems="center"
        justifyContent="center"
        direction="column"
      >
        <ErrorOutlined
          fontSize="small"
          style={{ fill: colorSet.errorBase, marginBottom: 8 }}
        />

        <CustomizedTypography
          variant="body2"
          color="textPrimary"
          align="center"
        >
          <span className="primary-text">{organizationName}</span>{' '}
          <span className="primary-text">{managerName}</span>님이 탈퇴하여
          상담이 종료되었습니다.
          <br />
          채팅 기록 및 관련 문서는 5년간 보관됩니다.
        </CustomizedTypography>
      </Grid>
      <Divider className="message-divider" />
    </div>
  );
};

export default TerminationBubble;
